// Profile card bios (Views/Partials/blockgrid/Components/peopleProfileBlock.cshtml).
// Each bio is a full-width grid row that follows its card in the markup. When opened it is
// moved after the last card on that card's row, so it opens beneath the row however many
// columns the grid has at the current width.
export function initProfileGrids() {
    document.querySelectorAll<HTMLElement>('[data-profile-grid]').forEach(grid => {
        const cards = Array.from(grid.querySelectorAll<HTMLElement>('[data-profile-card]'));
        // Each bio row remembers its card, as moving it breaks the markup order.
        const owners = new Map<HTMLElement, HTMLElement>();
        grid.querySelectorAll<HTMLElement>('[data-profile-bio-row]').forEach(row => {
            const card = row.previousElementSibling as HTMLElement | null;
            if (card?.matches('[data-profile-card]')) {
                owners.set(row, card);
            }
        });

        const placeBelowRow = (bioRow: HTMLElement) => {
            const card = owners.get(bioRow);
            if (!card) {
                return;
            }
            const top = card.offsetTop;
            const rowEnd = cards.filter(c => c.offsetTop === top).pop() ?? card;
            rowEnd.after(bioRow);
        };

        owners.forEach((card, bioRow) => {
            const collapse = bioRow.querySelector<HTMLElement>('.collapse');
            if (!collapse) {
                return;
            }

            collapse.addEventListener('show.bs.collapse', () => {
                placeBelowRow(bioRow);
                bioRow.hidden = false;
                card.classList.add('is-open');
            });
            collapse.addEventListener('hide.bs.collapse', () => {
                card.classList.remove('is-open');
            });
            collapse.addEventListener('hidden.bs.collapse', () => {
                bioRow.hidden = true;
            });
        });

        // The column count changes with the width, so an open bio follows its row.
        let frame = 0;
        window.addEventListener('resize', () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                owners.forEach((_, bioRow) => {
                    if (!bioRow.hidden) {
                        placeBelowRow(bioRow);
                    }
                });
            });
        });
    });
}
